import { render, staticRenderFns } from "./SelfAssessmentAccelerationTest.vue?vue&type=template&id=17e97859&scoped=true&"
import script from "./SelfAssessmentAccelerationTest.vue?vue&type=script&lang=ts&"
export * from "./SelfAssessmentAccelerationTest.vue?vue&type=script&lang=ts&"
import style0 from "./SelfAssessmentAccelerationTest.vue?vue&type=style&index=0&id=17e97859&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e97859",
  null
  
)

export default component.exports